import * as React from 'react';
import { useQuery } from 'urql';

import Loader from '../../shared/components/Loader';
import Error from '../components/Error';
import { ISentData, sentQuery } from './query';
import SentMessage from './SentMessage';

function Sent(): JSX.Element {
    const [open, setOpen] = React.useState<string>('');

    const [result] = useQuery<ISentData>({
        query: sentQuery,
    });
    const toggleOpen = React.useCallback((id: string) => {
        setOpen(open => open === id ? '' : id);
    }, [setOpen]);

    if (result.fetching) {
        return <Loader />;
    } else if (result.error) {
        return <Error />;
    }

    return <section>
        {result.data.learningCoachMessageList.map(message => <SentMessage
            key={message.id}
            message={message}
            open={open === message.id}
            toggleOpen={toggleOpen}
        />)}
    </section>;
}

export default Sent;
